type GetTopicSuffixesOptions = {
  topic: string;
  conversationId?: string | null;
};

/**
 * Builds topic suffixes for Satellite WebSocket subscriptions.
 * Always subscribes to the inbox topic, and optionally subscribes
 * to a specific conversation topic when a conversationId is provided.
 */
export const getTopicSuffixes = ({ topic, conversationId }: GetTopicSuffixesOptions): Array<string> => {
  const topics = [`|inbox:${topic}`];

  if (conversationId) {
    topics.push(`|conversation:${conversationId}:${topic}`);
  }

  return topics;
};
